// @flow

import * as React from 'react'
import { colors } from '@toggl/style'

type IconProps = {
  color?: string,
}

export const Youtube = ({ color }: IconProps) => (
  <svg viewBox="0 0 23 16" version="1.1" fill={color || colors.beige}>
    <g id="Symbols" stroke="none" strokeWidth="1" fillRule="evenodd">
      <g
        id="Footer-product"
        transform="translate(-731.000000, -520.000000)"
        fillRule="nonzero"
      >
        <g id="subbar" transform="translate(0.000000, 501.000000)">
          <g id="Group-30" transform="translate(588.000000, 18.000000)">
            <g id="youtube" transform="translate(143.000000, 1.000000)">
              <path
                d="M22.3488858,2.5 C22.0858287,1.52245821 21.3151114,0.751915053 20.3377437,0.488683855 C18.5520543,0 11.4092967,0 11.4092967,0 C11.4092967,0 4.26671309,0 2.48102369,0.47005571 C1.52245821,0.733112825 0.732938696,1.52263229 0.469881627,2.5 C0,4.28551532 0,7.98850977 0,7.98850977 C0,7.98850977 0,11.7101323 0.469881627,13.4770195 C0.733112825,14.4543872 1.50365598,15.2251044 2.48119777,15.4883356 C4.28551532,15.9770195 11.4094708,15.9770195 11.4094708,15.9770195 C11.4094708,15.9770195 18.5520543,15.9770195 20.3377437,15.5069638 C21.3152855,15.2439067 22.0858287,14.4731894 22.3490599,13.4958217 C22.8190374,11.7101323 22.8190374,8.00731196 22.8190374,8.00731196 C22.8190374,8.00731196 22.8377437,4.28551532 22.3488858,2.5 Z"
                id="Path"
              ></path>
              <polygon
                id="Path"
                fill="rgba(0,0,0,1)"
                points="9.13509749 11.4094708 15.0746866 7.98850977 9.13509749 4.56754875"
              ></polygon>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)
